import { Preloader } from '@smartsheet/lodestar-core';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchExtensions,
  fetchExtensionRegistrationData,
} from '../../../services/ducks/extensionsDuck/extensionsDuck';
import {
  fetchModules,
  selectAllModules,
} from '../../../services/ducks/modulesDuck/modulesDuck';
import { fetchProvider } from '../../../services/ducks/providerDuck/providerDuck';
import { fetchSchedules } from '../../../services/ducks/schedulesDuck';
import {
  fetchWorkflowData,
  workflowDataSelector,
  workflowNameSelector,
  workflowUUIDSelector,
} from '../../../services/ducks/workflowDuck/workflowDuck';
import {
  fetchWorkspaceData,
  workspaceNameSelector,
} from '../../../services/ducks/workspaceDuck/workspaceDuck';
import { getWorkspaceUUID } from '../../../utils/apiRequests';
import { Canvas } from '../../features/Canvas';
import { DesignerHeaderBar } from '../../features/DesignerHeaderBar/DesignerHeaderBar';
import { RightRail } from '../../features/RightRail';
import { DraggedModule } from '../../features/RightRail/DraggedModule';
import { LoadingContainer } from './LoadingContainer';

export const Designer = () => {
  const { t: translate } = useTranslation();

  interface RouteParams {
    workflowRef: string;
  }
  const { workflowRef } = useParams<RouteParams>();
  const workspaceUUID = getWorkspaceUUID();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchWorkflowData(workflowRef));
  }, [dispatch, workflowRef]);

  useEffect(() => {
    dispatch(fetchWorkspaceData(workspaceUUID));
  }, [dispatch, workspaceUUID]);

  const workflowUUID = useSelector(workflowUUIDSelector);
  useEffect(() => {
    dispatch(fetchSchedules(workflowUUID));
  }, [dispatch, workflowUUID]);

  useEffect(() => {
    dispatch(fetchSchedules(workflowUUID));
  }, [dispatch, workflowUUID]);

  useEffect(() => {
    batch(() => {
      dispatch(fetchExtensions());
      dispatch(fetchModules());
      dispatch(fetchProvider());
      dispatch(fetchExtensionRegistrationData());
    });
  }, [dispatch]);

  const workspaceName = useSelector(workspaceNameSelector);
  const workflowName = useSelector(workflowNameSelector);
  const workflowData = useSelector(workflowDataSelector);
  const modules = useSelector(selectAllModules);

  return (
    <>
      <Helmet>
        <title>
          {workflowData.intent !== ''
            ? workflowData.intent
            : translate('designer:title')}{' '}
          - Bridge by Smartsheet
        </title>
      </Helmet>
      {workflowData.objectUUID !== '' && modules.length ? (
        <>
          <DesignerHeaderBar
            workspaceName={workspaceName}
            workflowName={workflowName}
            backButtonHandler={() => {
              window.location.href = `${window.location.origin}#/dashboard/recent`;
            }}
            navigateToHelp={() => {
              window.open('https://help.smartsheet.com/bridge', '_blank');
            }}
            navigateToFeedback={() => {
              window.open(
                'https://app.smartsheet.com/b/form/739aa75f30ca43a8a22eb53e4da7d409?_ga=2.167762814.1130402529.1606148380-1505269246.1605744950&What%20is%20your%20feedback%20about%3F=Bridge%20by%20Smartsheet',
                '_blank'
              );
            }}
          />
          <Canvas workflowData={workflowData} />
          <RightRail />
          <DraggedModule />
        </>
      ) : (
        <LoadingContainer>
          <Preloader />
        </LoadingContainer>
      )}
    </>
  );
};
